import { SYSBaseElement } from "../../sysbaseelement"
import type { CellClass } from "../../table/row"
import type { SYSField } from "../actions"
//import type { SYSFileDropEventData } from "../sysformelement"
import { FocusSet } from "../../../global/globalapi"
import { _SetFocus } from "../../../global/globals"
import { HookFieldGetValueRender } from "../../../global/hooks"
import { DialogOpen } from "../../dialog/dialogapi"
import { _GetAlign, GetRowDisplayValue } from "../../table/helpers"
import { SYSTableDef } from "../../table/table"
import { TableGet } from "../../table/tableapi"
import { FormEditorInit } from "../formapi"
import { GetRowFromFormState } from "./helpers"

export class SYSControlBase extends SYSBaseElement {
  props: any
  field: SYSField
  inputElement: any
  valueRenderHookFn: any
  tableDef: SYSTableDef

  customInfo: {
    customRowClassName: string
    customRowTooltip: string
    customRowClassContainerName: string
  }
  focusable: boolean
  wasFocusedWhenDisabled: boolean

  async handleEditorEnter(e: KeyboardEvent) {
    if (e.key === "Enter") {
      this.handleEditor(e)
    }
  }

  async handleEditor(e: Event) {
    if (this.field.editor) {
      if (!this.field.ui.alwaysReadOnly && !this.field.ui.readonly) {
        e.preventDefault()
        let editorFormState = await FormEditorInit(
          this.field.editor.id,
          // fields will be filled with HookFormProvideFields
          {},
          this.formState,
          this.field.fieldKey
        )
        if (editorFormState === undefined) {
          // there is smth wrong or it was canceled by the user
          return
        }
        DialogOpen(this.field.editor.id, {
          instance: editorFormState.formId,
          formsHandling: [
            {
              formType: this.field.editor.id,
              formId: editorFormState.formId,
              removeFormStateWhenClose: true,
            },
          ],
        })
      }
    }
  }

  getCustomInfo(customRowCell: CellClass) {
    let key = this.field.fieldKey
    let customRowClassName = ""
    let customRowTooltip
    let customRowClassContainerName = ""
    if (customRowCell?.[key]) {
      if (customRowCell[key].className) {
        customRowClassName = customRowCell[key].className
        customRowClassContainerName = customRowClassName + "Container"
      }
      customRowTooltip = customRowCell[key].tooltip
    }
    return { customRowClassName, customRowTooltip, customRowClassContainerName }
  }

  getOutlineValidationHint() {
    if (this.field.inactive) {
      return ""
    }
    let outlineValidationHint = ""
    let allValidation = this.field.validationResult.System.concat(
      this.field.validationResult.Validate
    ).concat(this.field.validationResult.ValueChanged)
    if (allValidation.length > 0) {
      outlineValidationHint = "is-warning"
      if (this.field.watched && !this.field.hasFocus) {
        outlineValidationHint = "is-error"
      }
    }
    return outlineValidationHint
  }

  getContainerClass(type: string, customRowClassName) {
    if (customRowClassName === undefined) {
      customRowClassName = ""
    }
    return `fd-form-item ovl-formcontrol-container ovl-container-${type} ovl-container__${this.field.fieldKey}  ${customRowClassName}`
  }

  getInputClass(type: string, customRowClassName, ignoreOutline?: boolean) {
    let field = this.field
    let outlineClass = ""
    if (!ignoreOutline) {
      outlineClass = this.getOutlineValidationHint()
    }

    let align = ""
    if (field.ui?.align) {
      align = _GetAlign(field.ui.align)
    }

    let focusable = ""

    if (this.focusable) {
      focusable = `ovl-focusable ${
        field.ui.selectIfFocused === true ? "ovl-focusselected" : ""
      }`
    }

    return `${align} ${outlineClass} ${customRowClassName} ${focusable} ${this.getEditorClass()} ovl-formcontrol-input ovl-value-${type} ovl-value__${
      field.fieldKey
    } ${!this.focusable ? "ovl-disabled" : ""} ${
      field.ui.addIgnoreFocusClass ? "ovl-ignoreautofocus" : ""
    }`
  }

  getEditorClass() {
    if (!this.field.editor) {
      return ""
    }
    return `ovl-editor ovl-editor__${this.field.editor.id.toString()}`
  }

  getReadOnly() {
    return (
      !!this.field.ui.readonly ||
      this.field.editor ||
      this.formState.locked ||
      this.field.ui.visible === "fadeOut"
    )
  }

  getHookValue(): any {
    if (this.valueRenderHookFn) {
      let res = GetRowDisplayValue(
        this.tableDef,
        this.field.fieldKey,
        GetRowFromFormState(this.formState),
        this.formState.tableRowKey,
        "Editor",
        false,
        this.valueRenderHookFn
      )
      return res
    }
  }

  // handleFormFileDragOver(e: DragEvent) {
  //   // dragover needs to be canceled. elsewise drop will not work as expected
  //   // but just do this for file transfers so other future drag and drop stuff shouldn't be affected
  //   if (e.dataTransfer.types.filter((f) => f === "Files").length > 0) {
  //     e.stopPropagation()
  //     e.preventDefault()
  //   }
  // }

  // handleFormFileDrop(e) {
  //   if (e.dataTransfer.files.length < 1) {
  //     return
  //   }

  //   let dropEventData: SYSFileDropEventData = {
  //     dragEvent: e,
  //     formState: this.formState,
  //     field: this.field,
  //   }
  //   const event = new CustomEvent("ovlformfiledrop", {
  //     detail: dropEventData,
  //     bubbles: true,
  //     cancelable: true,
  //   })

  //   this.dispatchEvent(event)
  // }

  handleAnimationEnd = (e) => {
    if (e.animationName === "fadeOutControl") {
      this.classList.remove("fadeOutControl")
      this.classList.add("ovl-hideControl")
      this.field._state.closing = false
      this.field._state.visible = false
    }
    if (e.animationName === "fadeInControl") {
      this.classList.remove("fadeInControl")
      this.field._state.closing = false
      this.field._state.visible = true
    }
  }
  async init() {
    if (!this.props) {
      return
    }
    this.field = this.props(this.state)
    this.formState =
      this.state.ovl.forms[this.field.formType][this.field.formId]
    // this.addEventListener("drop", (e) => this.handleFormFileDrop(e))
    // this.addEventListener("dragover", (e) => this.handleFormFileDragOver(e))
    this.addEventListener("keydown", (e) => this.handleEditorEnter(e))
    if (this.field.editor && this.field.editor.id !== "SYSEditorAsset") {
      // Assets Click neeeds to be registered sep. because elsewise it interferes with the click send to input file
      this.addEventListener("click", (e) => this.handleEditor(e))
    }
    this.valueRenderHookFn =
      this.actions.app.features?.[this.formState.feature]?.hooks?.[
        HookFieldGetValueRender.replace(
          "{subFeature}",
          this.formState.subFeature
        ).replace("{fieldKey}", this.field.fieldKey)
      ]
    if (this.formState.tableDefId) {
      this.tableDef = TableGet(this.formState.tableDefId).def
    }

    await super.init()
  }
  InitControl() {
    if (!this.props) {
      return
    }
    this.field = this.props(this.state)

    this.classList.add(`ovl-control-container`)
    this.classList.add(`ovl-control-container__${this.field.fieldKey}`)

    if (
      !this.field._state.visible &&
      this.field.ui.visible !== "fadeIn" &&
      !this.field.ui.fillSpaceIfNotVisible
    ) {
      return false
    }

    // setTimeout(async () => {
    //   if (!this.field) {
    //     return
    //   }
    //   let autoFillChk = document.getElementById(
    //     `${this.field.formType}_${this.field.formId}_${this.field.fieldKey}`
    //   )
    //   if (autoFillChk) {
    //     if (!FieldIsDirty(this.field)) {
    //       let val = autoFillChk.value
    //       let fieldVal = this.field.convertedValue

    //       // if the field is valid. bute there
    //       if (val && !fieldVal) {
    //         console.log(
    //           "autofill detected... setValue",
    //           this.field.fieldKey,
    //           val,
    //           fieldVal
    //         )
    //         await FieldSetVal(this.field, val)
    //       }
    //     }
    //   }
    // }, 300)

    this.customInfo = this.getCustomInfo(this.formState._state._viewRowCell)

    if (this.customInfo.customRowTooltip) {
      this.setAttribute("title", this.customInfo.customRowTooltip)
    } else {
      this.removeAttribute("title")
    }

    if (this.field.ui.readonly) {
      this.classList.add("ovl-disabled__cursor-not-allowed")
    } else {
      this.classList.remove("ovl-disabled__cursor-not-allowed")
    }

    if (!this.field._state.visible && this.field.ui.visible !== "fadeIn") {
      this.classList.add("ovl-hideControl")
    }
    this.id = "ovl_" + this.field.id

    this.focusable = !(
      this.field.ui.readonly ||
      this.formState.locked ||
      this.field.ui.visible === "false" ||
      this.field.ui.visible.indexOf("fadeOut") > -1
    )

    if (
      !this.focusable &&
      this.inputElement &&
      this.inputElement.id === document.activeElement?.id
    ) {
      this.wasFocusedWhenDisabled = true
    }
    if (this.focusable && this.wasFocusedWhenDisabled) {
      this.wasFocusedWhenDisabled = false
      setTimeout(() => {
        if (this.inputElement?.id) {
          _SetFocus(this.inputElement.id)
        }
      }, 0)
    }
  }

  // this is needed because other methods still allow to tab into the control
  async connectedCallback() {
    await super.connectedCallback()
    this.setAttribute("title", "")
    this.addEventListener("animationend", this.handleAnimationEnd)
    //this.field = this.formState.fields[this.field.fieldKey]

    //this.addEventListener("animationstart", this.handleAnimationStart, true)
  }
  async disconnectedCallback() {
    //make sure if the control was set to visible/not visible using fadeX
    // that the visible state gets set even if the animation didn't finish
    if (this.field) {
      if (this.field.ui.visible === "fadeOut" && this.field._state.visible) {
        this.field._state.visible = false
      } else if (
        this.field.ui.visible === "fadeIn" &&
        !this.field._state.visible
      ) {
        this.field._state.visible = true
      }
    }
    this.removeEventListener("animationend", this.handleAnimationEnd)
    // this.removeEventListener("drop", (e) => this.handleFormFileDrop(e))
    // this.removeEventListener("dragover", (e) => this.handleFormFileDragOver(e))

    this.removeEventListener("click", (e) => this.handleEditor(e))
    this.removeEventListener("keyup", (e) => this.handleEditorEnter(e))
    this.field = null
    this.props = null
    this.customInfo = null
    this.inputElement = null

    await super.disconnectedCallback()
  }
  //  async firstUpdated() {
  //      // check if it has autocomplete
  //      // if control is autocomplete control and it has the autocomplete css mark and there was no setvalue for a given period
  //      // auto issue setvalue with current control value
  //      if (this.field.ui.autocomplete &&  !this.field._state.valueWasSet)
  //  }

  async firstUpdated() {
    if (
      this.formState.forceFocusWhenVisibleFieldKey &&
      this.field.fieldKey === this.formState.forceFocusWhenVisibleFieldKey
    ) {
      if (FocusSet(this.field.id)) {
      }
      // FieldSetFocus(
      //   this.formState.fields[this.formState.forceFocusWhenVisibleFieldKey]
      // )
      this.formState.forceFocusWhenVisibleFieldKey = undefined
    }
  }
  async afterRender() {
    if (this.classList.contains("ovl-hideControl")) {
      if ("false,fadeOut".indexOf(this.field.ui.visible) < 0) {
        this.classList.remove("ovl-hideControl")
      }
    }
  }
}
